import {
    canUseChromeMessagePort,
    getChromeMessagePort,
} from "./extension-messaging.ts";
import type {Mailbox} from "./types.ts";

/**
 * A mailbox that sends messages to the Khan Academy browser extension.
 *
 * Currently, this only supports Chrome.
 */
export class ExtensionMailbox implements Mailbox {
    /**
     * Send a message to this mailbox.
     *
     * @param message The message to send.
     */
    send(message: string): void {
        // Add data object wrapper around message to match the format that
        // window.postMessage uses so that signal handling is consistent
        // between the extension and mobile.
        getChromeMessagePort()?.postMessage({
            data: message,
        });
    }

    /**
     * Is this mailbox available?
     *
     * `true` if this mailbox can be used to send messages; otherwise, `false`.
     */
    get canSend(): boolean {
        return canUseChromeMessagePort();
    }
}
